export default "__VITE_ASSET__xjeglk00__"